import axios from 'axios';
import { store } from '../store';
import { doLogoutApp } from '../store/ducks/auth/actions';
import { getAccessToken, getRefreshToken, setAccessToken, setRefreshToken } from "../config/cookies";

const url = (process.env.REACT_APP_API_BASE_URL || window.location.origin) + '/api/';

const logoutApp = () => {
  const accessToken = getAccessToken();
  store.dispatch(doLogoutApp(accessToken));
  window.location.href = '/exit';
};

const api = axios.create({
  baseURL: url,
  
});

// Esse bloco so deve ser utilizado em desenvolvimento local, não pode ser commitado na versão para HML ou PRD!!!
// api.interceptors.request.use(
//  async config => {
//    if (config.url?.includes('chatbot/')) {
//      config.baseURL = 'http://localhost:8090/api/';
//      return config;
//    }

//    return config;
//  },
//  error => {
//    return Promise.reject(error);
//  },
// );

const PUBLIC_ENDPOINTS = ['auth/callback', 'auth/refreshToken'];

const isPublicEndpoint = (requestUrl: string) =>
  PUBLIC_ENDPOINTS.some((endpoint) => requestUrl.startsWith(endpoint));

api.interceptors.request.use((config: any) => {
  if (isPublicEndpoint(config.url ?? '')) return config;
  if (config.headers?.Authorization) return config;

  const token = getAccessToken();
  if (token) {
    config.headers = { ...config.headers, Authorization: `Bearer ${token}` };
  }

  return config;
});

api.interceptors.response.use((response: any) => {
  return response;
}, (error: any) => {
  const originalRequest = error.config;
  if (!error.response) {
      return Promise.reject('Network Error');
  } else if ((error.response.status === 401) && !originalRequest._retry) {
    originalRequest._retry = true;
    const chave = getRefreshToken();

    if (!chave) {
      logoutApp();
      return Promise.reject(error);
    }

    const chaveToken = {
        refreshToken: chave
    };
    return axios.post(url + 'auth/refreshToken', chaveToken, {
      headers: {
          'Content-Type': 'application/json',
      },
    }).then( res => {
      setAccessToken(res.data.accessToken);
      setRefreshToken(res.data.chaveToken);
      api.defaults.headers.common['Authorization'] = 'Bearer ' + res.data.accessToken;
      originalRequest.headers['Authorization'] = 'Bearer ' + res.data.accessToken;

      return axios(originalRequest);
    }).catch(err => {
      logoutApp();
      return Promise.reject(err);
    })
  } else {
    return Promise.reject(error);
  }
})

export default api;
